<template>
  <div class="row societePage">
    <div
      class="col-md-12"
      v-if="(!this.$props.addClt && !isLightMode) || (onEditionId === null && isLightMode)"
    >
      <List
        :__list="dataArray"
        :__isLightMode="this.isLightMode"
        :__isOnLoad="isListOnload"
        :__editMode="drawerMode ? false : this.onEditionId != null"
        :__idxOnEdition="drawerMode ? -1 : this.onEditionIdx"
        :__onSelect = "this.onSelect"
        ></List>
    </div>

    <div class="col-md-12" v-if="!drawerMode && onEditionId !== null">
      <Edit
        v-if='addClt === false'
        :__item="onEditionItem"
        :__isLightMode="this.isLightMode"
        :__isOnLoad="isEditOnload"
        :__onSelect = "this.onSelect"
      ></Edit>

      <New
        v-if='addClt === true'
        :__item="onEditionItem"
        :__isOnLoad="isEditOnload"
        :email-verification-requested="emailVerification.requested"
        :email-verification-verified="emailVerification.verified"
        :email-verification-code="emailVerification.code"
        :email-verification-remaining="emailVerification.remaining"
        :email-verification-busy="emailVerification.sending || emailVerification.confirming"
        @request-email-verification="requestEmailVerification"
        @confirm-email-verification="confirmEmailVerification()"
        @update-email-verification-code="emailVerification.code = $event"
      ></New>
    </div>

    <transition name="societeEditorOverlay">
      <div
        v-if="drawerMode && onEditionId !== null"
        class="societeEditorBackdrop"
        @click="cancelAction"
      ></div>
    </transition>

    <transition name="societeEditorDrawer">
      <div
        v-if="drawerMode && onEditionId !== null"
        class="societeEditorDrawer"
        @click.stop
      >
        <div class="societeEditorHead">
          <div class="societeEditorTitle">
            {{ onEditionIdx === -1 ? 'Nouveau client' : 'Modifier client' }}
          </div>
          <button type="button" class="societeEditorClose" @click="cancelAction">×</button>
        </div>

        <Edit
          :__item="onEditionItem"
          :__isLightMode="this.isLightMode"
          :__isOnLoad="isEditOnload"
          :__onSelect = "this.onSelect"
        ></Edit>
      </div>
    </transition>
  </div>
</template>
<script>
import Vue from "vue";
import Edit from './Edit';
import New from './New';
import List from './List';
export default {
  components: {
    Edit,
    List,
    New
  },
  props: {
    addClt:  {
      type: Boolean,
      default: () => {
        return false;
      },
    },

    isLightMode:  {
      type: Boolean,
      default: () => {
        return false;
      },
    },

    onSelect: {
        type: Function,
        default: () => {()=>{}},
      },
  },

  data() {
    return {
      moduleRoute: '/societes',
      onEditionId: null,
      onEditionIdx: -1,
      onEditionItem: null,
      onEditionCopie: null,
      isListOnload: false,
      isEditOnload: false,
      dataArray: [],
      onGoingReq:[],
      emailVerification: {
        code: '',
        email: '',
        requested: false,
        verified: false,
        remaining: 0,
        sending: false,
        confirming: false,
        timer: null,
      },
    };
  },

  computed: {
    drawerMode() {
      return this.$props.addClt !== true && this.$props.isLightMode === false;
    },
  },

  methods: {
    createEmptyItem() {
      return {
        nrc: '',
        mf: '',
        logo: '',
        ville: '',
        fax: '',
        name: '',
        email: '',
        tel: '',
        adress: '',
        isActive: 1,
        cd: '',
        banque: '',
        rib: '',
        login: '',
        pwd: '',
      };
    },

    showToast(message, variant = 'success') {
      this.$bvToast.toast(message, {
        title: variant === 'success' ? 'Client' : 'Ajout client',
        variant,
        solid: true,
        autoHideDelay: 4000,
      });
    },

    getValidationError(item, { isRegistration = false } = {}) {
      if (!item || !item.name || item.name.trim() === '') {
        return "Le nom de la société est obligatoire.";
      }

      if (item.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(item.email).trim())) {
        return "L'adresse email n'est pas valide.";
      }

      if (isRegistration) {
        if (!item.tel || item.tel.trim() === '') {
          return "Le téléphone est obligatoire pour l'inscription.";
        }
        if (!item.email || item.email.trim() === '') {
          return "L'email est obligatoire pour l'inscription.";
        }
        if (!item.login || item.login.trim() === '') {
          return "Le login est obligatoire pour l'inscription.";
        }
        if (!item.pwd || item.pwd.trim() === '') {
          return "Le mot de passe est obligatoire pour l'inscription.";
        }
        if (String(item.pwd).length < 8 || !/[A-Za-z]/.test(String(item.pwd)) || !/\d/.test(String(item.pwd))) {
          return 'Le mot de passe doit contenir au moins 8 caracteres, une lettre et un chiffre.';
        }
      }

      return null;
    },

    createClientAccountForSociete(societeId, conf = {}) {
      const payload = {
        type: 'CLIENT',
        pid: societeId,
        login: this.onEditionItem.login || this.onEditionItem.email || '',
        name: this.onEditionItem.name || '',
        email: this.onEditionItem.email || '',
        pwd: this.onEditionItem.pwd || '',
        emailVerificationId: this.onEditionItem.emailVerificationId || '',
      };

      if (!payload.login || !payload.email || !payload.pwd) {
        if (conf.$onNext) conf.$onNext();
        return;
      }

      this.__.httpAction({
        methode: 'PUT',
        route: '/admins',
        data: payload,
        onNext: () => {
          if (conf.$onNext) conf.$onNext();
        },
        onError: () => {
          if (conf.$onError) conf.$onError();
        },
        onComplete: () => {
          if (conf.$onComplete) conf.$onComplete();
        },
      });
    },

    cancelAction() {
      this.onEditionId = null;
      this.onEditionIdx = -1;
      this.onEditionItem = null;
    },

    copieAction() {
      this.saveAction();
    },

    saveAction() {
      if (this.onEditionId === '__draft__') {
        this.createAction();
        return;
      }

      this.onGoingReq.push({});
      let $onNext = (response) => {
        if(this.$props.addClt &&  this.onEditionCopie !== null) {
          Vue.$cookies.set('user',{
            type: 'GUEST',
            ID: this.onEditionCopie._id,
            name: this.onEditionCopie.name
          });
          this.$router.push('/')  
        }
        else {
          this.loadData(this.onEditionId, null, this.onEditionIdx);
        }
        
      };
      
      const $onError = () => {};
      const $onComplete = () => {
        if (this.onGoingReq.length > 0) this.onGoingReq.pop();
      };
      let diff = this.__.differ(
        this.dataArray[this.onEditionIdx],
        this.onEditionItem
      );
      diff.push('_id');
      let data = this._.pick(this.onEditionItem, diff);
      
      this.updateAction({ $onNext, $onError, $onComplete, data });
    },

    toggleActivateAction(id, val) {
      const findIdx = (element) => element._id == id;
      var idx = this.dataArray.findIndex(findIdx);
      this.onGoingReq.push({});
      let $onNext = (response) => {
        this.dataArray[idx].isActive = val;
      };

      const $onError = () => {};
      const $onComplete = () => {
        if (this.onGoingReq.length > 0) this.onGoingReq.pop();
      };

      let data = this._.pick(this.dataArray[idx], ['_id', 'isActive']);
      data.isActive = val;
      this.updateAction({ $onNext, $onError, $onComplete, data });
    },

    deleteAction(id) {
      const findIdx = (element) => element._id == id;
      var idx = this.dataArray.findIndex(findIdx);
      this.onGoingReq.push({});
      let $onNext = (response) => {
        if (response.data == 'OK') {
          this.dataArray.splice(idx, 1);
        }
      };

      const $onError = () => {};
      const $onComplete = () => {
        if (this.onGoingReq.length > 0) this.onGoingReq.pop();
      };

      let data = this._.pick(this.dataArray[idx], ['_id']);
      this.__.httpAction({
        methode: 'DELETE',
        route: this.moduleRoute+"/"+data._id,
        data: {},
        onNext: $onNext,
        onError: $onError,
        onComplete: $onComplete,
      });
    },

    editAction(id) {
      const findIdx = (element) => element._id == id;
      var idx = this.dataArray.findIndex(findIdx)
      this.onEditionId = id;
      this.onEditionIdx = idx;
      this.onEditionItem = this._.omit(this.dataArray[idx]);
      if(this.$props.addClt && this.onEditionCopie !== null) {

        this.onEditionItem =  this.onEditionCopie;
        this.onEditionIdx = 0
        this.onEditionId = this.onEditionItem._id = this.dataArray[this.onEditionIdx]._id
        this.saveAction()
      }
    },

    updateAction(conf) {
      this.__.httpAction({
        methode: 'POST',
        route: this.moduleRoute,
        data: conf.data,
        onNext: conf.$onNext,
        onError: conf.$onError,
        onComplete: conf.$onComplete,
      });
    },

    createAction() {
      const validationError = this.getValidationError(this.onEditionItem, {
        isRegistration: this.$props.addClt,
      });

      if (validationError) {
        this.showToast(validationError, 'danger');
        return;
      }

      if (this.$props.addClt && (!this.onEditionItem.emailVerificationId || !this.emailVerification.verified)) {
        if (!this.emailVerification.requested) {
          this.requestEmailVerification();
          return;
        }
        if (!/^\d{6}$/.test(this.emailVerification.code)) {
          this.showToast('Saisissez le code de verification a 6 chiffres envoye par email.', 'danger');
          return;
        }
        this.confirmEmailVerification(true);
        return;
      }

      this.onGoingReq.push({});
      const $onNext = (response) => {
        const createdId = response.data;

        if (this.$props.addClt) {
          this.createClientAccountForSociete(createdId, {
            $onNext: () => {
              Vue.$cookies.set('user', {
                type: 'GUEST',
                ID: createdId,
                name: this.onEditionItem.name,
              });
              Vue.$cookies.set('registrationSuccess', this.onEditionItem.name);
              this.$router.push('/catalogue');
            },
            $onError: () => {
              this.showToast("Le compte client n'a pas pu etre cree. Veuillez verifier les informations saisies.", 'danger');
            },
          });
          return;
        }

        if (this.onEditionItem.login || this.onEditionItem.email) {
          this.createClientAccountForSociete(createdId, {
            $onNext: () => {
              this.loadData(createdId, () => {
                this.cancelAction();
                this.showToast('Le client a ete ajoute avec succes.');
              });
            },
            $onError: () => {
              this.loadData(createdId, () => {
                this.cancelAction();
                this.showToast('Le client a ete ajoute avec succes.');
              });
            },
          });
          return;
        }

        this.loadData(createdId, () => {
          this.cancelAction();
          this.showToast('Le client a ete ajoute avec succes.');
        });
      };

      const $onError = () => {
        this.showToast("Le client n'a pas pu etre ajoute. Veuillez reessayer.", 'danger');
      };
      const $onComplete = () => {
        if (this.onGoingReq.length > 0) this.onGoingReq.pop();
      };

      const data = this._.omit({ ...this.onEditionItem }, ['_id', 'emailVerificationId']);
      this.__.httpAction({
        methode: 'PUT',
        route: this.moduleRoute,
        data,
        onNext: $onNext,
        onError: $onError,
        onComplete: $onComplete,
      });
    },

    addAction() {
      this.resetEmailVerification();
      this.onEditionId = '__draft__';
      this.onEditionIdx = -1;
      this.onEditionItem = this.createEmptyItem();
    },

    requestEmailVerification() {
      const email = String(this.onEditionItem.email || '').trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        this.showToast('Saisissez une adresse email valide avant de demander le code.', 'danger');
        return;
      }
      this.emailVerification.sending = true;
      this.__.httpAction({
        methode: 'POST',
        route: '/email-verifications/request',
        data: { email },
        onNext: () => {
          this.emailVerification.code = '';
          this.emailVerification.email = email;
          this.emailVerification.requested = true;
          this.emailVerification.verified = false;
          this.onEditionItem.emailVerificationId = '';
          this.startEmailVerificationTimer();
          this.showToast('Le code de verification a ete envoye. Il est valable pendant 10 minutes.');
        },
        onError: (error) => {
          this.showToast(error.response && error.response.data && error.response.data.message ? error.response.data.message : "Le code n'a pas pu etre envoye.", 'danger');
        },
        onComplete: () => {
          this.emailVerification.sending = false;
        },
      });
    },

    confirmEmailVerification(createAfterConfirmation = false) {
      if (!/^\d{6}$/.test(this.emailVerification.code)) {
        this.showToast('Le code de verification doit contenir 6 chiffres.', 'danger');
        return;
      }
      this.emailVerification.confirming = true;
      this.__.httpAction({
        methode: 'POST',
        route: '/email-verifications/confirm',
        data: { email: this.onEditionItem.email, code: this.emailVerification.code },
        onNext: (response) => {
          this.onEditionItem.emailVerificationId = response.data.verificationId;
          this.emailVerification.verified = true;
          this.emailVerification.requested = false;
          this.emailVerification.remaining = 0;
          this.stopEmailVerificationTimer();
          this.showToast('Adresse email confirmee.');
          if (createAfterConfirmation) this.createAction();
        },
        onError: (error) => {
          this.showToast(error.response && error.response.data && error.response.data.message ? error.response.data.message : 'Code de verification incorrect.', 'danger');
        },
        onComplete: () => {
          this.emailVerification.confirming = false;
        },
      });
    },

    startEmailVerificationTimer() {
      this.stopEmailVerificationTimer();
      const expiresAt = Date.now() + (10 * 60 * 1000);
      const updateRemaining = () => {
        this.emailVerification.remaining = Math.max(0, Math.ceil((expiresAt - Date.now()) / 1000));
        if (this.emailVerification.remaining === 0) {
          this.emailVerification.requested = false;
          this.emailVerification.code = '';
          this.stopEmailVerificationTimer();
        }
      };
      updateRemaining();
      this.emailVerification.timer = window.setInterval(updateRemaining, 1000);
    },

    stopEmailVerificationTimer() {
      if (this.emailVerification.timer) {
        window.clearInterval(this.emailVerification.timer);
        this.emailVerification.timer = null;
      }
    },

    resetEmailVerification() {
      this.stopEmailVerificationTimer();
      this.emailVerification.code = '';
      this.emailVerification.email = '';
      this.emailVerification.requested = false;
      this.emailVerification.verified = false;
      this.emailVerification.remaining = 0;
      this.emailVerification.sending = false;
      this.emailVerification.confirming = false;
    },

    loadData(id = null, cb = null, putAt = null) {
      let $onNext = (response) => {
        if (id != null) {
          if (putAt != null) {
            if(putAt === -1) {
              const idx = (element) => element._id === id;
              var position = this.dataArray.findIndex(idx)
              this.dataArray[position] = response.data[0];
            } else {
              this.dataArray[putAt] = response.data[0];
            }
            
          } else {
            this.dataArray.unshift(response.data[0]);
          }

          if (cb) cb();
        } else {
          this.dataArray = response.data;
        }
      };

      const $onError = () => {};
      const $onComplete = () => {
        if (this.onGoingReq.length > 0) this.onGoingReq.pop();
      };

      this.onGoingReq.push({});
      this.__.httpAction({
        methode: 'GET',
        route: this.moduleRoute+ (id != null ? '/'+id : '/'),
        data: {},
        onNext: $onNext,
        onError: $onError,
        onComplete: $onComplete,
      });
    },
    
  },
  mounted() {
    //this.patch();
    if(this.$props.addClt) {
      this.addAction();
    } else {
      this.loadData();
    }
    
  },

  watch: {
    onGoingReq: function () {
      this.isListOnload = this.isEditOnload = this.onGoingReq.length > 0;
    },
    'onEditionItem.email': function (email) {
      if (this.emailVerification.email && String(email || '').trim().toLowerCase() !== this.emailVerification.email.toLowerCase()) {
        this.resetEmailVerification();
        if (this.onEditionItem) this.onEditionItem.emailVerificationId = '';
      }
    },
  },
  beforeDestroy() {
    this.stopEmailVerificationTimer();
  },
};
</script>
<style scoped>
.societePage {
  position: relative;
}

.societeEditorBackdrop {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.2);
  z-index: 336;
}

.societeEditorDrawer {
  position: fixed;
  top: 175px;
  left: 50%;
  width: min(820px, calc(100vw - 48px));
  max-height: calc(100vh - 195px);
  overflow-x: hidden;
  overflow-y: auto;
  padding: 18px;
  border-radius: 20px;
  background: #eef1f5;
  box-shadow: 0 24px 55px rgba(15, 23, 42, 0.22);
  border: 1px solid rgba(226, 232, 240, 0.95);
  z-index: 337;
  transform: translateX(-50%);
}

.societeEditorHead {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 14px;
}

.societeEditorTitle {
  font-size: 18px;
  font-weight: 700;
  color: #0f172a;
}

.societeEditorClose {
  width: 36px;
  height: 36px;
  border: none;
  border-radius: 999px;
  background: #ffffff;
  color: #334155;
  font-size: 24px;
  line-height: 1;
  cursor: pointer;
  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.12);
}

.societeEditorDrawer-enter-active,
.societeEditorDrawer-leave-active {
  transition: transform 0.3s ease, opacity 0.3s ease;
}

.societeEditorDrawer-enter,
.societeEditorDrawer-leave-to {
  transform: translate(-50%, 24px) scale(0.985);
  opacity: 0;
}

.societeEditorOverlay-enter-active,
.societeEditorOverlay-leave-active {
  transition: opacity 0.22s ease;
}

.societeEditorOverlay-enter,
.societeEditorOverlay-leave-to {
  opacity: 0;
}

@media (max-width: 768px) {
  .societeEditorDrawer {
    top: 110px;
    width: calc(100vw - 20px);
    max-height: calc(100vh - 125px);
    padding: 14px;
    border-radius: 16px;
  }
}
</style>
